<app-header></app-header>
<ion-content
  id="menu-profit-pro"
  class="gray-content-bg"
  [ngClass]="(platformService?.isTouchExperience$ | async) ? platformService?.platformType === platformService?.platformEnum?.tablet ? 'tablet' : 'mobile' : 'desktop'"
  *ngIf="(viewModel$ | async) as viewModel"
>
  <ng-template #fourTiles>
    <div
      class="fourTileContainer"
      [class.mobile]="platformService.platformType === platformService.platformEnum.mobile"
    >
      <div class="leftTileContainer">
        <app-image-tile
          [platform]="platformService.platformType"
          [imageItem]="viewModel.images[0]"
          (clickEvent)="goToFromImage($event)"
        ></app-image-tile>
        <app-image-tile
          [platform]="platformService.platformType"
          [imageItem]="viewModel.images[1]"
          (clickEvent)="goToFromImage($event)"
        ></app-image-tile>
      </div>
      <div class="rightTileContainer">
        <app-image-tile
          [platform]="platformService.platformType"
          [imageItem]="viewModel.images[2]"
          (clickEvent)="goToFromImage($event)"
        ></app-image-tile>
        <app-image-tile
          [platform]="platformService.platformType"
          [imageItem]="viewModel.images[3]"
          (clickEvent)="goToFromImage($event)"
        ></app-image-tile>
      </div>
    </div>
  </ng-template>
  <app-page-title-banner
    *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
    [pageTitle]="'i18n.menuProfitPro.pageTitle' | translate"
    [backgroundImageStyle]="backgroundImageStyle"
    [overlayGradient]="overlayGradient"
    [showEllipsis]="false"
  ></app-page-title-banner>

  <app-sub-menu
    [currentPage]="currentPage"
    [translateService]="translateService"
    [items]="viewModel.subMenuItems"
    [platform]="platformService.platformType"
    (clickEvent)="gotoRequest($event)"
    [class.mobile]="platformService?.platformType === platformService?.platformEnum?.mobile"
  >
  </app-sub-menu>

  <ion-grid
    data-cy="menu-profit-pro-content"
    class="menu-profit-pro-content"
    [fixed]="true"
  >
    <!-- tiles -->
    <ion-row
      class="bump-16"
      *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
    >
      <ion-col size="7">
        <ng-cotainer
          *ngIf="viewModel.images.length > 0"
          [ngTemplateOutlet]="fourTiles"
        ></ng-cotainer>
      </ion-col>
      <ion-col offset="0.5" size="4.5">
        <app-innovate-tile
          [platform]="platformService.platformType"
        ></app-innovate-tile>
      </ion-col>
    </ion-row>

    <ion-row
      class="bump-16"
      *ngIf="platformService?.platformType !== platformService?.platformEnum?.desktop"
    >
      <ion-col size="12">
        <ng-cotainer
          *ngIf="viewModel.images.length > 0"
          [ngTemplateOutlet]="fourTiles"
        ></ng-cotainer>
      </ion-col>
    </ion-row>

    <ion-row
      class="bump-16"
      *ngIf="platformService?.platformType !== platformService?.platformEnum?.desktop"
    >
      <ion-col [size]="12">
        <app-innovate-tile
          [platform]="platformService.platformType"
        ></app-innovate-tile>
      </ion-col>
    </ion-row>

    <!-- analytics -->
    <ion-row> </ion-row>

    <!-- profitable items -->
    <ion-row> </ion-row>

    <!-- reports and utils -->
    <ion-row></ion-row>

    <!-- spacing REMOVE when we a more developed page -->
    <ion-row>
      <div class="spacing"></div>
    </ion-row>
  </ion-grid>
  <app-footer></app-footer>

  <ion-modal
    [isOpen]="mppService.createMppModalIsOpen"
    (ionModalDidDismiss)="mppService.handleCreateMppDismiss()"
    [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
    [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 1] : undefined"
    [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' :'modal-desktop-size-xl'"
  >
    <ng-template>
      <app-create-mpp-modal
        class="ion-page"
        [platform]="platformService.platformType"
        [data]="mppService.createMppDataModalData"
        [title]="createMppTitel"
        [typeSelection]="defaultCreateMppSelction"
        (submitEvent)="mppService.handleCreateMppSubmission($event)"
        (dismissEvent)="mppService.handleCreateMppDismiss()"
      >
      </app-create-mpp-modal>
    </ng-template>
  </ion-modal>
</ion-content>
